type LoadingModuleProps = {
  title?: string;
};
/**
 * ### Para utilizar en los import dinamicos, tipicamente el fallback del Suspense
 *
 * ```
 * import React, { Suspense } from "react";
 *
 * import { LoadingModule } from "@/components";
 *
 * const AccountabilityRoutesLazy = React.lazy(() => import("./AccountabilityRoutes"));
 *
 * export default function RoutesLazy() {
 *   return (
 *     <Suspense fallback={<LoadingModule />}>
 *       <AccountabilityRoutesLazy />
 *     </Suspense>
 *   );
 * }
 * ```
 */

export function LoadingModule({ title = "cargando modulo..." }: LoadingModuleProps) {
  return (
    <div className="flex h-full w-full items-center justify-center text-rdc-grayLight">{title}</div>
  );
}
